import dynamic from "next/dynamic";
import React from "react";
import CarModels from "@/app/components/CarModels/CarModels";
import CarModelMobile from "@/app/components/CarModels/CarModelsMobile";

// Importação dinâmica dos componentes
const ContactForm = dynamic(
  () => import("@/app/components/ContactForm/ContactForm"),
  {
    loading: () => <div>Carregando...</div>,
    ssr: false,
  }
);

const SolicitarProposta = dynamic(
  () => import("@/app/components/KintoComponents/KIntoForm"),
  { loading: () => <div>Carregando...</div>, ssr: false }
);

const KintoOneFleet = dynamic(
  () => import("@/app/components/KintoComponents/KintoOneFleet"),
  { loading: () => <div>Carregando...</div>, ssr: false }
);

const KintoOnePersonal = dynamic(
  () => import("@/app/components/KintoComponents/KintoOnePersonal"),
  { loading: () => <div>Carregando...</div>, ssr: false }
);

const KintoOneShare = dynamic(
  () => import("@/app/components/KintoComponents/KintoOneShare"),
  { loading: () => <div>Carregando...</div>, ssr: false }
);

const KintoApp: React.FC = () => {
  return (
    <div>
      <main className="flex flex-col items-center bg-neutral-100 pt-16 lg:pt-10">
        <div className="flex flex-col w-full">
          <KintoOneFleet />
          <div className="w-full lg:hidden">
            <ContactForm />
          </div>
          <KintoOnePersonal />
          <KintoOneShare />
          <div className="w-full max-lg:hidden">
            <SolicitarProposta />
          </div>
          <div className="w-full max-lg:hidden">
            <CarModels />
          </div>
        </div>
      </main>
    </div>
  );
};

export default KintoApp;
